import { InjectionToken } from '@angular/core';
import { SubmissionSetupState } from '../types/submission-setup.types';

export const SUBMISSION_SETUP_INITIAL_STATE: SubmissionSetupState = {
  error: null,
  isLoading: false,
  workspaceTypes: [],
  workspaceSubTypes: [],
  studySites: [],
  selectedWorkspaceType: null,
  selectedWorkspaceSubType: null,
  totalWorkspaceTypes: 0,
  totalWorkspaceSubTypes: 0,
  grandTotalStudySitesCount: 0,
  filteredStudySitesCount: 0,
  totalStudySitesCount: 0,
  reviewLocations: [],
  totalReviewLocations: 0,
  studies: [],
  totalStudies: 0,
  studiesLoading: false,
  studyColumns: {},
  siteColumns: {},
  submission: null,
  workspaceId: null,
  navigationEnabled: false,
  createdSubmissionResponse: null,
};

export const SUBMISSION_SETUP_INITIAL_STATE_TOKEN =
  new InjectionToken<SubmissionSetupState>('Submission Setup Initial State', {
    factory: () => ({ ...SUBMISSION_SETUP_INITIAL_STATE }),
  });
